import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class DateJson {
    jour: number;
    mois: number;
    annee: number;

  constructor(dateAFormater: any) {
    if (dateAFormater instanceof  Date) {
      this.jour = dateAFormater.getDate();
      this.mois = dateAFormater.getMonth();
      this.annee = dateAFormater.getFullYear();
    } else {
      this.jour = dateAFormater.day;
      this.mois = dateAFormater.month;
      this.annee = dateAFormater.year;
    }
  }

  getDateFormat(): string {
    return this.padNumber(this.jour) + "/" + this.padNumber(this.mois) + "/" + this.annee;
  }

  private padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    } else {
      return '';
    }
  }

  private isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }

  toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }
}


// WEBPACK FOOTER //
// ./src/app/outils/dateJson.ts